import { TrackingHandler } from './TrackingHandler';
import { BrowserProvider } from './providers/BrowserProvider';
import { PageProvider } from './providers/PageProvider';
import { LocalStorageProvider } from './providers/LocalStorageProvider';
import { FallbackProvider } from './providers/FallbackProvider';
import { SessionStorageProvider } from './providers/SessionStorageProvider';
import { EgroupParameterProvider } from './providers/EgroupParameterProvider';
import { GtmListener } from './listeners/GtmListener';
import { NewGtmListener } from './listeners/NewGtmListener';
import { LocalStorageListener } from './listeners/LocalStorageListener';
import { CookiesListener } from './listeners/CookiesListener';
import { SessionStorageListener } from './listeners/SessionStorageListener';
import { LoggerListener } from './listeners/LoggerListener';
import { ServerSideGtmListener } from './listeners/ServerSideGtmListener';
import { PhoneTrackingListener } from './listeners/PhoneTrackingListener';
import { ExternalTrackingListener } from './listeners/ExternalTrackingListener';
import { initRecaptcha } from '../helpers/captchas';
import { CalendarLinkListener } from './listeners/CalendarLinkListener';
import { HotJarListener } from './listeners/HotJarListener';
import { SalesViewerListener } from './listeners/SalesViewerListener';
export const initTracking = () => {
    const trackingHandler = TrackingHandler.getInstance();
    window.trackingHandler = trackingHandler;
    trackingHandler.providers.push(new EgroupParameterProvider());
    trackingHandler.providers.push(new PageProvider());
    trackingHandler.providers.push(new BrowserProvider());
    trackingHandler.providers.push(new SessionStorageProvider());
    trackingHandler.providers.push(new LocalStorageProvider());
    trackingHandler.providers.push(new FallbackProvider());
    trackingHandler.listeners.push(new CookiesListener());
    trackingHandler.listeners.push(new SessionStorageListener());
    trackingHandler.listeners.push(new LocalStorageListener());
    trackingHandler.listeners.push(new LoggerListener());
    trackingHandler.listeners.push(new GtmListener());
    trackingHandler.listeners.push(new NewGtmListener());
    trackingHandler.listeners.push(new ServerSideGtmListener());
    trackingHandler.listeners.push(new PhoneTrackingListener());
    trackingHandler.listeners.push(new ExternalTrackingListener());
    trackingHandler.listeners.push(new CalendarLinkListener());
    trackingHandler.listeners.push(new HotJarListener());
    trackingHandler.listeners.push(new SalesViewerListener());
    trackingHandler.pageReady();
    if (window.siteSettings.disableCookieConsent) {
        trackingHandler.setConsent(true, true, true);
        initRecaptcha();
        return;
    }
    window.addEventListener('ucEvent', (e) => {
        const ucEvent = e.detail;
        if (ucEvent.action === 'onInitialPageLoad' && ucEvent.type === 'implicit') {
            return;
        }
        initRecaptcha();
        trackingHandler.setConsent(ucEvent.ucCategory.essential, ucEvent.ucCategory.functional, ucEvent.ucCategory.marketing);
    });
};
